var React = require('react');

function LogoShapeLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M195.994 170.583V262.163L30.516 149.623C21.1872 143.243 13.5272 134.615 8.20704 124.496C2.88688 114.377 0.0689061 103.074 0 91.5796V0L165.478 112.54C174.846 118.878 182.536 127.497 187.861 137.626C193.186 147.754 195.981 159.077 195.994 170.583Z","fill":"#476FD7"}));
}

LogoShapeLeft.defaultProps = {"viewBox":"0 0 196 263"};

module.exports = LogoShapeLeft;

LogoShapeLeft.default = LogoShapeLeft;
